import React from 'react'
import { createRoot } from 'react-dom/client'
import { useLocation } from 'react-router-dom'

import AuthProvider from './providers/AuthProvider'
import ThemeProvider from './providers/ThemeProvider'
import MediaProvider from './providers/MediaProvider'
import DataProvider from './providers/DataProvider'
import TableProvider from './providers/TableProvider'
import AccessControlProvider from './providers/AccessControlProvider'

import App from './pages'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import createStore from './store'

const store = createStore()
const container: HTMLElement = document.getElementById('root') as HTMLElement
const root = createRoot(container)

const isDevelopment = process.env.NODE_ENV !== 'development';

root.render(
  isDevelopment ? (
    <React.StrictMode>
      <Provider store={store}>
        <AuthProvider>
          <ThemeProvider>
            <AccessControlProvider>
              <DataProvider useLocation={useLocation}>

                <MediaProvider>
                  <App />
                </MediaProvider>

              </DataProvider>
            </AccessControlProvider>
          </ThemeProvider>
        </AuthProvider>
      </Provider>
    </React.StrictMode>
  ) : (
    <Provider store={store}>
      <AuthProvider>
        <ThemeProvider>
          <AccessControlProvider>
            <DataProvider useLocation={useLocation}>

              <MediaProvider>
                <App />
              </MediaProvider>

            </DataProvider>
          </AccessControlProvider>
        </ThemeProvider>
      </AuthProvider>
    </Provider>
  )
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
